import React from 'react';
import { Button } from './ui/button';
import { Phone, ArrowRight, Mail } from 'lucide-react';
import { contactInfo } from '../mock';

export const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative pt-32 lg:pt-28 overflow-hidden">
      {/* Full-Width Hero Image */}
      <div className="relative h-[900px] w-full">
        <img 
          src="https://customer-assets.emergentagent.com/job_pro-trucker-learn/artifacts/gy8js52e_DTS-Web-Hero-Image.jpg" 
          alt="Diamond Trucking School - Professional CDL Training" 
          className="w-full h-full object-cover"
        />
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40"></div>
        
        {/* Hero Content Overlay */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl">
              <button
                onClick={scrollToContact}
                data-testid="hero-enroll-now-btn"
                className="inline-block bg-[#d97706] hover:bg-[#b45309] text-white px-5 py-2.5 rounded-full text-lg font-bold animate-pulse hover:animate-none mb-6 tracking-[0.2em] uppercase cursor-pointer shadow-lg hover:shadow-xl transition-colors"
              >
                ENROLL NOW — SEATS ARE LIMITED
              </button>
              
              <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight mb-6">
                Start Your
                <span className="text-[#d97706]"> Trucking Career</span> Today
              </h1>
              
              <p className="text-xl md:text-2xl text-gray-200 leading-relaxed mb-8">
                Professional CDL training with experienced instructors. Get certified in weeks and start earning a great salary with job security.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-10">
                <Button 
                  onClick={scrollToContact}
                  size="lg" 
                  className="bg-[#d97706] hover:bg-[#b45309] text-white text-xl px-10 py-7 shadow-lg hover:shadow-xl transition-all"
                >
                  Get Started Now
                  <ArrowRight className="ml-2 w-6 h-6" />
                </Button>
                
                <Button 
                  onClick={() => window.location.href = `tel:${contactInfo.phone}`}
                  size="lg" 
                  variant="outline"
                  className="border-2 border-white text-white hover:bg-white hover:text-[#1e3a5f] text-xl px-10 py-7 transition-all"
                >
                  <Phone className="mr-2 w-6 h-6" />
                  Call Now
                </Button>

                <Button 
                  onClick={() => window.location.href = 'mailto:diamondtruckingschool@gmail.com'}
                  size="lg" 
                  variant="outline"
                  data-testid="email-now-btn"
                  className="border-2 border-[#d97706] text-[#d97706] hover:bg-[#d97706] hover:text-white text-xl px-10 py-7 transition-all"
                >
                  <Mail className="mr-2 w-6 h-6" />
                  Email Now
                </Button>
              </div>

              {/* Value Proposition */}
              <div className="pt-6 border-t border-white/30">
                <h3 className="text-2xl md:text-3xl font-bold text-[#d97706] mb-3">
                  Ready for a high‑paying career?
                </h3>
                <p className="text-lg md:text-xl text-white italic leading-relaxed">
                  Students get accelerated, hands‑on CDL & HAZMAT training that's employer‑aligned.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};